import React, { useEffect } from "react";
import { 
    Background,
} from './styles'
import Header from "../../common/Header/index"
import NewFooter from "../../common/NewFooter"

const Chart = () => {
  
    useEffect(() => {
      document.getElementById('chart').scrollIntoView(); 
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(
        <>
            <Header/>
            <Background id="chart">
                <p>Chart</p>
            </Background>
            <NewFooter/>
        </>
    )
}
export default Chart;
